<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <div id="CYB_PC_PR_02_01" class="modal type-mo-full" data-popup>
    <div class="dialog type-large">
      <header class="dialog-header">
        <h2 class="dialog-title only-pc">배송지 수정</h2>
        <button type="button" class="dialog-close" data-popup-close>
          <span class="c-icon icon-large-x"></span>
          <span class="sr-only">팝업 닫기</span>
        </button>
      </header>

      <div class="dialog-content">
        <div class="dialog-content-inner">
          <!-- D: MO에서만 존재 -->
          <h3 class="c-title-level3 only-mo">배송지 수정</h3>

          <form action="" class="table-form-wrap">
            <div class="c-btn-area flex-ar">
              <button
                type="button"
                class="c-util-button type-line-black type-small"
              >
                <span>초기화</span>
              </button>
            </div>

            <div class="c-table-form">
              <table>
                <caption>
                  배송지 수정 폼
                </caption>
                <colgroup>
                  <col style="width: 19.2%" class="only-pc" />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row" class="only-pc">
                      <div class="label">주소지 별칭<br />(최대 10자)</div>
                    </th>
                    <td>
                      <div class="label only-mo">
                        주소지 별칭<br />(최대 10자)
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            maxlength="10"
                            value="주소지 별칭"
                            title="주소지 별칭"
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="only-pc">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        받는 분<br />(최대 10자)
                      </div>
                    </th>
                    <td>
                      <div class="label only-mo">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        받는 분<br />(최대 10자)
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            maxlength="10"
                            value="받는 분"
                            title="받는 분"
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="vct only-pc">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        휴대폰 번호
                      </div>
                    </th>
                    <td>
                      <div class="label only-mo">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        휴대폰 번호
                      </div>
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select name="" id="">
                            <option value="">010</option>
                            <option value="">011</option>
                            <option value="">012</option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input type="text" title="휴대폰 번호" />
                        </label>
                        <button
                          type="button"
                          class="c-button type-line-black type-small type-icon"
                        >
                          <i class="c-icon icon-plus-black"></i>
                          <span class="sr-only">필드 추가</span>
                        </button>
                      </div>
                      <!-- D: 삭제 케이스 -->
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select name="" id="">
                            <option value="">010</option>
                            <option value="">011</option>
                            <option value="">012</option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input type="text" title="휴대폰 번호" />
                        </label>
                        <!-- D: 삭제버튼 icon만 다름 -->
                        <button
                          type="button"
                          class="c-button type-line-black type-small type-icon"
                        >
                          <i class="c-icon icon-medium-x2"></i>
                          <span class="sr-only">필드 추가</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="vct only-pc">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        유선전화
                      </div>
                    </th>
                    <td>
                      <div class="label only-mo">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        유선전화
                      </div>
                      <div class="c-form-field type-phone">
                        <div class="c-select">
                          <select name="" id="">
                            <option value="">031</option>
                          </select>
                        </div>
                        <span class="hyphen">-</span>
                        <label class="c-input-group">
                          <input type="text" title="유선전화" />
                        </label>
                        <button
                          type="button"
                          class="c-button type-line-black type-small type-icon"
                        >
                          <i class="c-icon icon-plus-black"></i>
                          <span class="sr-only">필드 추가</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row" class="vct only-pc">
                      <div class="label">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        주소
                      </div>
                    </th>
                    <td>
                      <div class="label only-mo">
                        <span class="c-required">
                          <span class="sr-only">필수</span>
                        </span>
                        주소
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input
                            type="text"
                            maxlength="10"
                            title="주소지 별칭"
                            readonly
                          />
                        </label>
                        <button
                          type="button"
                          class="c-button type-line-black type-small"
                        >
                          <span class="fw-nr">우편번호 찾기</span>
                        </button>
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input type="text" title="주소" readonly />
                        </label>
                      </div>
                      <div class="c-form-field">
                        <label class="c-input-group">
                          <input type="text" title="상세 주소" />
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>

      <div class="dialog-footer">
        <div class="c-btn-area">
          <button type="button" class="c-button type-secondary">
            <span>취소</span>
          </button>
          <button type="button" class="c-button type-primary">
            <span>저장</span>
          </button>
        </div>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>
<script>
export default {
  props: {},
  setup() {
    return {};
  },
};
</script>
